import React from "react";

const DestinationGallery = () => {
  return (
    <div className="vs-destination-gallery-style1 overflow-hidden">
      <div className="row destination-gallery">
      <span className="sec-subtitle fade-anim text-center py-2" data-direction="bottom">
               Popular Destination
              </span>
        <div className="col-lg-6 p-0">
          <div className="destination-gallery-box h-100">
            <img
              src="/images/lonavala.avif"
              alt="destination-gallery"
              className="w-100 h-100"
            />
            <div className="icon-box">
              <a
                href="/images/lonavala.avif"
                title="Destination Gallery-1"
                className=""
              >
                <i className="fa-solid fa-eye"></i>
              </a>
            </div>
            <span className="content"> Lonavala </span>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="row">
            <div className="col-sm-6 p-0">
              <div className="destination-gallery-box h-100">
                <img
                  src="/images/lavasa.jpg"
                  alt="destination-gallery"
                  className="w-100 h-100"
                />
                <div className="icon-box">
                  <a
                    href="/images/lavasa.jpg"
                    title="Destination Gallery-1"
                    className=""
                  >
                    <i className="fa-solid fa-eye"></i>
                  </a>
                </div>
                <span className="content"> Lavasa </span>
              </div>
            </div>
            <div className="col-sm-6 p-0">
              <div className="destination-gallery-box h-100">
                <img
                  src="/images/Mahabaleshwar.jpg"
                  alt="destination-gallery"
                  className="w-100 h-100"
                />
                <div className="icon-box">
                  <a
                    href="/images/Mahabaleshwar.jpg"
                    title="Destination Gallery-1"
                    className=""
                  >
                    <i className="fa-solid fa-eye"></i>
                  </a>
                </div>
                <span className="content"> Mahabaleshwar </span>
              </div>
            </div>
            <div className="col-sm-6 p-0">
              <div className="destination-gallery-box h-100">
                <img
                  src="/images/mumbai.webp"
                  alt="destination-gallery"
                  className="w-100 h-100"
                />
                <div className="icon-box">
                  <a
                    href="/images/mumbai.webp"
                    title="Destination Gallery-1"
                    className=""
                  >
                    <i className="fa-solid fa-eye"></i>
                  </a>
                </div>
                <span className="content"> Mumbai </span>
              </div>
            </div>
           
            <div className="col-sm-6 p-0">
              <div className="destination-gallery-box h-100">
                <img
                  src="/images/shirdi.jpg"
                  alt="destination-gallery"
                  className="w-100 h-100"
                />
                <div className="icon-box">
                  <a
                    href="/images/shirdi.jpg"
                    title="Destination Gallery-1"
                    className=""
                  >
                    <i className="fa-solid fa-eye"></i>
                  </a>
                </div>
                <span className="content"> Shirdi </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DestinationGallery;
